module.exports = __webpack_public_path__ + "static/media/2.b2396f70.webp";